module.exports = __webpack_public_path__ + "static/img/NSW-31.e86c4d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-31.jpg
// module id = lFg7
// module chunks = 0